<script>

	import { onMount } from 'svelte';
	import moment from 'moment-es6';
	import _ from "lodash-es";

	let jsonResponse = [];

  $: feed = sortByMostRecent(_.values(groupByDate(jsonResponse)));

	var sortByMostRecent = function(days) {
		return days.sort(function (a, b) {
	    return new Date(b.date) - new Date(a.date);
	  });
	}

	var sortByTime = function(reviews) {
		return reviews.sort(function (a, b) {
	    return new Date(b.timestamp) - new Date(a.timestamp);
	  });
	}

	var sum = function(sum, review) {
		return sum + review.rating;
	}

	var createBinge = function(watch) {
		watch = _.sortBy(watch, [function(o) { return o.epkey; }]);
		let binge = watch[0];
		binge.epkey = watch[0].epkey + ' - ' + watch[watch.length-1].epkey;
		binge.time = watch[watch.length-1].time;
		binge.rating = _.reduce(watch, sum, 0);
		return binge;
	}

	var createBingeWatches = function(watch) {
		return (watch.length <= 1) ? _.flatten(watch) : createBinge(watch);
	}

	var combineBinges = function(reviews) {
		let binges = _.values(_.groupBy(reviews, "slug"));
		return _.flatten(_.map(binges, createBingeWatches));
	}

	var groupByDate = function(reviews) {
		// console.log(reviews.tvLog);
		// let reviews = reviews.tvLog;
		let days = _.groupBy(reviews.map(gatherReviews), "date");
		return _.map(days, gatherDays);
	}

	var gatherDays = function(day) {
		return { 'date': day[0].date, 'reviews': sortByTime(combineBinges(day)), 'smdate': moment(day[0].date).format('M.D') };
	}

	var gatherReviews = function(review) {
		review.date = (review.timestamp).slice(0,10);
		review.time = review.timestamp.slice(10, 19);
		return review;
	}

	onMount(async () => {
		const res = await fetch(`https://api.sheety.co/34fbc9c8972e54151317c3cd24d8587d/aharontv/tvLog`);
		const json = await res.json();
		jsonResponse = json.tvLog;
	});

</script>

<slot {feed} />
